import React from 'react';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import InputAdornment from "@material-ui/core/InputAdornment";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import { Divider, Hidden } from '@material-ui/core';

import MyLocation from "@material-ui/icons/MyLocation";
import MailOutline from "@material-ui/icons/MailOutline";
import LocationOn from "@material-ui/icons/LocationOn";
import Map from "@material-ui/icons/Map";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

import { store } from '../../../redux/store';
import { ADD_CUSTOMER_FORM_CHANGE } from '../../../redux/types';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

class AddressStateObject {
    address = "";
    addressState = "";
    postal_code = "";
    postal_codeState = "";
}

class Address extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            physical: props.defaultPhysical || new AddressStateObject(),
            postal: props.defaultPostal || new AddressStateObject()
        };

        if(this.state.physical.address)
            this.state.physical.addressState = "success";
        if(this.state.postal.address)
            this.state.postal.addressState = "success";

        if(this.state.physical.postal_code && this.verifyPostal(this.state.physical.postal_code))
            this.state.physical.postal_codeState = "success";
        if(this.state.postal.postal_code && this.verifyPostal(this.state.postal.postal_code))
            this.state.postal.postal_codeState = "success";
            
    }
    sendState() {
        return this.state;
    }
    verifyPostal(value) {
        var postalRex = /^\d{4,8}$/
        if (postalRex.test(value)) {
            return true;
        }
        return false;
    }
    verifyLength(value, length) {
        if (value.length >= length) {
            return true;
        }
        return false;
    }
    change = (event, name, type = "required", contactType) => {

        var new_state = { [name + "State"]: this.state[contactType][name + "State"] };

        switch (type) {
            case "required":
                if (event.target.value && event.target.value.trim()) {
                    new_state[name + "State"] = "success";
                } else {
                    new_state[name + "State"] = "error";
                }
                break;
            case "postal":
                if (this.verifyPostal(event.target.value)) {
                    new_state[name + "State"] = "success";
                } else {
                    new_state[name + "State"] = "error";
                }
                break;
            default:
                break;
        }

        if(this.props.isPrepaid)
            new_state[name + "State"] = "success";

        this.setState({ [contactType]: { ...this.state[contactType], ...new_state, [name]: event.target.value } });
        store.dispatch({ type: ADD_CUSTOMER_FORM_CHANGE, name, payload: event.target.value, subtype: contactType });
    }
    isValidated() {
        console.log(this.state);
        if (
            this.state.physical.addressState === "success" &&
            this.state.postal.addressState === "success" &&
            this.state.physical.postal_codeState === "success" &&
            this.state.postal.postal_codeState === "success"
            || this.props.isPrepaid
        ) {
            return true;
        } else {

            var new_physical = { ...this.state.physical };
            var new_postal = { ...this.state.postal };

            if (this.state.physical.addressState !== "success") {
                new_physical = { ...new_physical, addressState: "error" };
            }
            if (this.state.postal.addressState !== "success") {
                new_postal = { ...new_postal, addressState: "error" };
            }

            if (this.state.physical.postal_codeState !== "success") {
                new_physical = { ...new_physical, postal_codeState: "error" };
            }
            if (this.state.postal.postal_codeState !== "success") {
                new_postal = { ...new_postal, postal_codeState: "error" };
            }

            this.setState({ physical: new_physical, postal: new_postal });
        }
        return false;
    }
    render() {
        const { classes } = this.props;
        return (
            <GridContainer justify="center">
                <GridItem xs={12} sm={12}>
                    <h4 className={classes.infoText}>
                        Address Information
                    </h4>
                </GridItem>
                <GridItem xs={11} sm={11} md={11} lg={5}>
                    <h4><LocationOn style={{ marginBottom: -5 }} />&nbsp;&nbsp;&nbsp;Physical Address</h4>
                    <Divider variant="middle" />
                    <CustomInput
                        success={this.state.physical.addressState === "success"}
                        error={this.state.physical.addressState === "error"}
                        labelText={
                            <span>
                                Address <small>(required)</small>
                            </span>
                        }
                        id="physical.address"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => {
                                if (event.target.value.split('\n').length <= 5)
                                    this.change(event, "address", "required", "physical")
                            },
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className={classes.inputAdornment}
                                >
                                    <Map className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            ),
                            value: this.state.physical.address,
                            multiline: true,
                            rowsMax: 5
                        }}
                    />
                    <CustomInput
                        success={this.state.physical.postal_codeState === "success"}
                        error={this.state.physical.postal_codeState === "error"}
                        labelText={
                            <span>
                                Postal Code <small>(required)</small>
                            </span>
                        }
                        id="physical.postal_code"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "postal_code", "postal", "physical"),
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className={classes.inputAdornment}
                                >
                                    <MyLocation className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            ),
                            value: this.state.physical.postal_code,
                        }}
                    />
                </GridItem>
                <Hidden xlUp>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                        <Divider variant="middle" style={{ marginTop: 20 }} />
                    </GridItem>
                </Hidden>
                <GridItem xs={11} sm={11} md={11} lg={5}>
                    <h4><MailOutline style={{ marginBottom: -5 }} />&nbsp;&nbsp;&nbsp;Postal Address</h4>
                    <Divider variant="middle" />
                    <CustomInput
                        success={this.state.postal.addressState === "success"}
                        error={this.state.postal.addressState === "error"}
                        labelText={
                            <span>
                                Address <small>(required)</small>
                            </span>
                        }
                        id="postal.address"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => {
                                if (event.target.value.split('\n').length <= 5)
                                    this.change(event, "address", "required", "postal")
                            },
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className={classes.inputAdornment}
                                >
                                    <Map className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            ),
                            value: this.state.postal.address,
                            multiline: true,
                            rowsMax: 5
                        }}
                    />
                    <CustomInput
                        success={this.state.postal.postal_codeState === "success"}
                        error={this.state.postal.postal_codeState === "error"}
                        labelText={
                            <span>
                                Postal Code <small>(required)</small>
                            </span>
                        }
                        id="postal.postal_code"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "postal_code", "postal", "postal"),
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className={classes.inputAdornment}
                                >
                                    <MyLocation className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            ),
                            value: this.state.postal.postal_code,
                        }}
                    />
                </GridItem>
            </GridContainer>
        );
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(Address);